import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "./theme-light.css";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
